module.exports = "/img/2.0ebb77.webp";